{
  "title": "How to Fill Out the Registration Form",
  "description": "Fill in your registration information during the registration window; the form saves automatically, and you can come back to edit it any time before the deadline.",
  "headings": [
    "What You'll Accomplish",
    "Applies To",
    "Before You Start",
    "Steps",
    "What You'll See",
    "FAQ"
  ],
  "summary": "When you're done, your registration data is saved and counts as submitted; unlike a submission, the registration form has no lock mechanism, so you can edit it any time before the registration deadline.",
  "roleNote": "Participant",
  "prerequisites": [
    "You've joined or created a team",
    "This competition's registration period hasn't ended"
  ],
  "pathLabel": "Competition Detail Page → Registration details",
  "steps": [
    {
      "title": "1. Open the registration info section",
      "description": "On the competition detail page's \"Registration details\" section, fill in the fields the organizer set up; whether a field is required is set by the organizer and may change between versions. Required fields carry a red asterisk. Some fields only appear for a particular choice (for example, choosing a Group reveals the fields for that group); when you change a choice, fields that no longer apply are hidden and the answers you had entered for them are cleared, so fill them in again under the new choice."
    },
    {
      "title": "2. Autosave and manual save",
      "description": "The form saves automatically as you type, and shows \"Autosaved\" with the time when it does; but it only saves once every required field is filled in and valid. While a required field is still empty the page says \"Some required fields are still empty. Your answers will be saved automatically once they are complete\", and nothing has been saved yet. A required checkbox (for example the Team declaration) must be ticked to count as filled in. You can also press \"Confirm and complete registration\" yourself (shown as \"Save changes\" once you have already registered)."
    },
    {
      "title": "3. Confirm completion",
      "description": "Once every required field passes validation and the save succeeds, your registration counts as submitted; the first time this happens the page shows a completion state."
    }
  ],
  "afterward": [
    "The screen shows a summary of your saved registration data",
    "Before the registration deadline you can click \"View / edit registration details\" to reopen the form; the button then reads \"Save changes\"",
    "You can re-save after editing — there's no version-lock mechanism",
    "After the registration deadline you can no longer save or change it, and the page says the registration period has ended; the deadline is the date shown on the competition page (the current round's registration deadline)",
    "If the organizer later changes the registration form, or your saved answers no longer meet the current form (for example a required checkbox is unticked), your registration shows \"Needs update\"; see the FAQ"
  ],
  "nextSteps": "Next, go to the submission form to start preparing the work you'll submit.",
  "faq": [
    {
      "q": "Does filling out the registration form complete my registration?",
      "a": "Yes — the registration form has no separate \"formal submit\" step; saving successfully completes your registration. This is different from a project submission, which needs an extra \"formal submit\" step."
    },
    {
      "q": "What if saving says a required field is missing?",
      "a": "The screen marks which field is missing or has an invalid format — fill it in as indicated and save again. A required checkbox (for example the Team declaration) that is not ticked also counts as missing."
    },
    {
      "q": "Does student eligibility verification block saving the registration form?",
      "a": "No. Even if the competition has \"Student Eligibility Verification\" enabled, it never blocks saving the registration form or completing registration — the two are independent. Your eligibility status shows separately as a completion tile in the \"Participation details\" summary panel, and you upload your enrollment proof and track review progress on the dedicated Student Eligibility page."
    },
    {
      "q": "What should I do when I see \"Registration needs an update\"?",
      "a": "It means your saved answers no longer meet the current form's required rules, for example a new required field was added, or the required Team declaration is not ticked. On the competition page, click \"Fill in registration\" on the Registration card, complete the missing fields, and press \"Save changes\", before the registration deadline. The platform never ticks a declaration for you and does not cancel your registration."
    },
    {
      "q": "If I refresh the page halfway through, will what I typed be lost?",
      "a": "Content is only saved once every required field is filled in and the autosave succeeds; while a required field is still empty nothing has been saved yet, so after a refresh you would need to fill it in again."
    }
  ]
}
